import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';

@Component({
  selector: 'app-vendordashboard',
  templateUrl: './vendordashboard.component.html',
  styleUrls: ['./vendordashboard.component.css']
})
export class VendordashboardComponent implements OnInit {
  PendingTasks:any;
  MessageCount:any;

  currentUserData: any;
  vendorData : any;
  enlistmentStepsData : any;
  enlistmentStepsSorted : any = [];

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService : VendordashboardService) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if(this.currentUserData != null)
        {
          var currentUserId = this.currentUserData.id;
          this.vendorDashboardService.getVendorData(currentUserId).subscribe(
            (data) => {
              this.vendorData = data;
              // if(this.vendorData.vendRegisterStatus == "pending" || 
              // this.vendorData.vendEnlistmentStatus == "pending" ||
              // this.vendorData.vendRegisterStatus == "completed" ||
              // this.vendorData.vendEnlistmentStatus == "completed")
              // {
                this.vendorDashboardService.getVendorEnlistmentSteps(currentUserId).subscribe(
                  (enlistdata) => {
                    this.enlistmentStepsData = enlistdata;
                    for(var i=0; i<this.enlistmentStepsData.length;i++)
                    {
                      var index = this.enlistmentStepsData[i].stepNo; 
                      this.enlistmentStepsSorted[index] =  this.enlistmentStepsData[i];
                    }
                    this.enlistmentStepsSorted.splice(0, 1);
                  }
                )
                this.vendorDashboardService.getPendingTasts(currentUserId).subscribe(
                  (data)=>{
                    this.PendingTasks=data;
                    console.log(this.PendingTasks);
      
                  }
                )
                this.vendorDashboardService.getMessageCount(currentUserId).subscribe(
                  (data)=>{
                    this.MessageCount=data;
                    console.log("messages"+this.MessageCount);
      
                  }
                )
      
              //}
            }
          )
        }
      }
    );

  }

}
